import InputView from '../views/InputView';
import ClipView from '../views/ClipView';
import ClipModel from '../models/ClipModel';


export default class App {
  constructor() {
    this.state = {
      url: 'https://www.googleapis.com/youtube/v3/search?key=AIzaSyDgg61Rp7mefcTkDX8MQOhY1axnva2chw0&type=video&part=snippet&order=viewCount&maxResults=15&q=dota',
      query: '',
    };
    this.placeholder = 'Search';
    this.clipCount = 15;
    this.pageCount = 0;
  }

  static addSlider() {
    const slider = document.querySelector('.scroll');
    const pageButtons = document.querySelectorAll('.information-controler__list-item');
    let isDown = false;
    let startX;
    // eslint-disable-next-line no-unused-vars
    let scrollLeft;
    let windowSize;
    let clipSize;
    let clipItemWindowCount;
    let clipCount = 15;
    let swipeCount = 0;
    let translate = 0;
    let walk;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      slider.parentElement.classList.add('active');
      startX = e.pageX - translate;
      // eslint-disable-next-line prefer-destructuring
      scrollLeft = slider.scrollLeft;
      windowSize = document.querySelector('.main').clientWidth;
      clipSize = document.querySelector('.information-item').clientWidth;
      clipItemWindowCount = Math.floor(windowSize / clipSize);
      console.log(clipSize);
      console.log(windowSize);
      console.log('clip');
      console.log(clipItemWindowCount);
      slider.style.transition = 'transform 0s';
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
      slider.parentElement.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      if (swipeCount * clipItemWindowCount + 4 > clipCount) {
        document.querySelector('.information-controler__border-block').click();
        clipCount += 15;
      }
      isDown = false;
      slider.classList.remove('active');
      slider.parentElement.classList.remove('active');
      slider.style.transition = 'transform 1s';
      let activePage;
      if (walk - translate < 0) {
        pageButtons.forEach((button, index) => {
          const but = button;
          but.innerHTML = index + 1 + 4 * Math.floor((swipeCount + 1) / 4);
        });
        activePage = (swipeCount + 1) % 4;
        translate -= windowSize;
        slider.style.transform = `translateX(${translate}px)`;
        document.querySelector('.active-page').classList.remove('active-page');
        pageButtons[activePage].classList.add('active-page');
        swipeCount += 1;
        document.querySelector('.information-controler-container').style.display = 'block';
      } else {
        if (swipeCount > 0) {
          pageButtons.forEach((button, index) => {
            const but = button;
            but.innerHTML = 4 * Math.floor((swipeCount - 1) / 4) + index + 1;
          });
          activePage = (swipeCount - 1) % 4;
          translate += windowSize;
          slider.style.transform = `translateX(${translate}px)`;
          document.querySelector('.active-page').classList.remove('active-page');
          pageButtons[activePage].classList.add('active-page');
          swipeCount -= 1;
        }
        return;
      }
      console.log(walk);
      console.log(windowSize);
      console.log(walk + windowSize);
    });
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      walk = (x - startX) * 1; // scroll-fast
      slider.style.transform = `translateX( -${slider.offsetLeft - walk}px)`;
      console.log(walk - translate);
    });

    slider.addEventListener('touchstart', (e) => {
      isDown = true;
      slider.classList.add('active');
      slider.parentElement.classList.add('active');
      startX = e.targetTouches[0].pageX - translate;
      // eslint-disable-next-line prefer-destructuring
      scrollLeft = slider.scrollLeft;
      windowSize = document.querySelector('.main').clientWidth;
      clipSize = document.querySelector('.information-item').clientWidth;
      clipItemWindowCount = Math.floor(windowSize / clipSize);
      slider.style.transition = 'transform 0s';
    });

    slider.addEventListener('touchend', () => {
      if (swipeCount * clipItemWindowCount + 4 > clipCount) {
        document.querySelector('.information-controler__border-block').click();
        clipCount += 15;
      }
      isDown = false;
      slider.classList.remove('active');
      slider.parentElement.classList.remove('active');
      slider.style.transition = 'transform 1s';
      let activePage;
      if (walk - translate < 0) {
        pageButtons.forEach((button, index) => {
          const but = button;
          but.innerHTML = index + 1 + 4 * Math.floor((swipeCount + 1) / 4);
        });
        activePage = (swipeCount + 1) % 4;
        translate -= windowSize;
        slider.style.transform = `translateX(${translate}px)`;
        document.querySelector('.active-page').classList.remove('active-page');
        pageButtons[activePage].classList.add('active-page');
        pageButtons[activePage].click();
        swipeCount += 1;
        document.querySelector('.information-controler-container').style.display = 'block';
      } else {
        if (swipeCount > 0) {
          pageButtons.forEach((button, index) => {
            const but = button;
            but.innerHTML = 4 * Math.floor((swipeCount - 1) / 4) + index + 1;
          });
          activePage = (swipeCount - 1) % 4;
          translate += windowSize;
          slider.style.transform = `translateX(${translate}px)`;
          document.querySelector('.active-page').classList.remove('active-page');
          pageButtons[activePage].classList.add('active-page');
          swipeCount -= 1;
        }

        return;
      }
      console.log(walk);
      console.log(windowSize);
      console.log(walk + windowSize);
    });

    slider.addEventListener('touchmove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.targetTouches[0].pageX - slider.offsetLeft;
      walk = (x - startX) * 1; // scroll-fast
      slider.style.transform = `translateX( -${slider.offsetLeft - walk}px)`;
      console.log(walk - translate);
    });

    pageButtons.forEach((pageButton) => {
      pageButton.addEventListener('click', () => {
        const oldPageNumber = document.querySelector('.active-page').innerHTML - 1;
        const newPageNumber = pageButton.innerHTML - 1;
        document.querySelector('.active-page').classList.remove('active-page');
        pageButton.classList.add('active-page');
        if (newPageNumber > oldPageNumber) {
          if (newPageNumber - oldPageNumber === 1) {
            slider.click();
          }
          translate -= (newPageNumber - oldPageNumber) * windowSize;
          slider.style.transform = `translateX(${translate}px)`;
          swipeCount += newPageNumber - oldPageNumber;
          console.log(swipeCount);
        } else {
          translate += (oldPageNumber - newPageNumber) * windowSize;
          slider.style.transform = `translateX(${translate}px)`;
          swipeCount -= (oldPageNumber - newPageNumber);
          console.log(swipeCount);
        }
      });
    });
  }

  async start() {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width; initial-scale=1';
    document.getElementsByTagName('head')[0].appendChild(meta);
    const clipModel = new ClipModel(this.clipCount);
    const clips = clipModel.creatClipList();
    const form = new InputView(this.placeholder);
    const clipList = new ClipView(clips);
    form.render();
    clipList.render();
    const searchButton = document.querySelector('.search-form__button');
    searchButton.addEventListener('click', async (e) => {
      await document.querySelector('main').remove();
      await clipList.render();
      App.addSlider();
      App.addControllerButtonEvent(clipModel);
      e.preventDefault();
      document.querySelector('.information-item-container').style.display = 'flex';
      clipModel.searchQuery = App.getQuery();
      this.state.url = clipModel.searchQuery;
      clipModel.setClipImg();
      clipModel.setClipNames();
      clipModel.setClipChannel();
      clipModel.setClipDate();
      clipModel.setClipDescription();
      await clipModel.setClipView();
      return false;
    });
  }


  static addControllerButtonEvent(clipModel) {
    const clipModelBuf = clipModel;
    const firstButton = document.querySelector('.information-controler__border-block');
    const query = App.getQuery();
    firstButton.addEventListener('click', async () => {
      clipModel.setClipNextTocken();
      const clips = clipModelBuf.creatClipList();
      clipModelBuf.searchQuery = `${query}&pageToken=${clipModel.nextPageToken}`;
      console.log(clipModelBuf.searchQuery);
      ClipView.renderAddingClip(clips);
      await clipModelBuf.setClipImg();
      await clipModelBuf.setClipNames();
      await clipModelBuf.setClipChannel();
      await clipModelBuf.setClipDate();
      await clipModelBuf.setClipDescription();
      await clipModelBuf.setClipView();
      clipModelBuf.searchQuer = query;
    });
  }

  static getQuery() {
    const inputValue = document.querySelector('.search-form__input').value;
    return `https://www.googleapis.com/youtube/v3/search?key=AIzaSyDgg61Rp7mefcTkDX8MQOhY1axnva2chw0&type=video&part=snippet&order=viewCount&maxResults=15&q=${inputValue}`;
  }
}
